import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query';
import { getBrands, getUserBrands, postBrand, updateBrand, deleteBrand } from '../services/Brands.ts';
import { toast } from 'react-hot-toast';

// Hook to fetch all brands (admin/general use)
export const useBrands = () => {
    return useQuery({
        queryKey: ['brands'],
        queryFn: async () => {
            const response = await getBrands(''); // Token handled by interceptor
            return response?.data;
        }
    });
};

// Hook to fetch brands for a specific user
export const useUserBrands = (userId?: string | number) => {
    return useQuery({
        queryKey: ['brands', 'user', userId],
        queryFn: async () => {
            const response = await getUserBrands('', userId); // Token handled by interceptor
            return response?.data;
        },
        enabled: !!userId,
    });
};

export const useCreateBrand = () => {
    const queryClient = useQueryClient();

    return useMutation({
        mutationFn: (data: any) => postBrand(data, ''), // Token handled by interceptor
        onSuccess: () => {
            queryClient.invalidateQueries({ queryKey: ['brands'] });
            toast.success('Brand created successfully');
        },
        onError: (error: any) => {
            const message = error?.response?.data?.message || 'Failed to create brand';
            toast.error(message);
        }
    });
};

export const useUpdateBrand = () => {
    const queryClient = useQueryClient();

    return useMutation({
        mutationFn: ({ id, data }: { id: string; data: any }) => updateBrand(id, data, ''), // Token handled by interceptor
        onSuccess: () => {
            queryClient.invalidateQueries({ queryKey: ['brands'] });
            toast.success('Brand updated successfully');
        },
        onError: (error: any) => {
            const message = error?.response?.data?.message || 'Failed to update brand';
            toast.error(message);
        }
    });
};

export const useDeleteBrand = () => {
    const queryClient = useQueryClient();

    return useMutation({
        mutationFn: (id: string) => deleteBrand(id, ''), // Token handled by interceptor
        onSuccess: () => {
            queryClient.invalidateQueries({ queryKey: ['brands'] });
            toast.success('Brand deleted successfully');
        },
        onError: (error: any) => {
            const message = error?.response?.data?.message || 'Failed to delete brand';
            toast.error(message);
        }
    });
};
